import { useQuery } from '@apollo/client/react'

import { graphql } from '~publish/graphql'

export const GetHomeSyncStatus = graphql(/* GraphQL */ `
  query GetHomeSyncStatus {
    account {
      id
      currentOrganization {
        id
        channels(input: { filter: { product: publish, isLocked: false } }) {
          id
          analytics {
            channelLastUpdatedAt
            postsLastUpdatedAt
          }
          comments {
            lastCheckedAt
          }
        }
      }
    }
  }
`)

export type AggregateSyncStatus = {
  loading: boolean
  postMetricsLastSyncedAt: Date | null
  channelMetricsLastSyncedAt: Date | null
  commentsLastSyncedAt: Date | null
  overallLastSyncedAt: Date | null
  channelCount: number
}

function newestOf(timestamps: Array<string | null | undefined>): Date | null {
  let newest: Date | null = null
  for (const timestamp of timestamps) {
    if (!timestamp) continue
    const date = new Date(timestamp)
    if (Number.isNaN(date.getTime())) continue
    if (newest === null || date > newest) {
      newest = date
    }
  }
  return newest
}

export function useAggregateSyncStatus(): AggregateSyncStatus {
  const { data, loading } = useQuery(GetHomeSyncStatus)

  const channels = data?.account?.currentOrganization?.channels ?? []

  const postMetricsLastSyncedAt = newestOf(
    channels.map((channel) => channel.analytics?.postsLastUpdatedAt),
  )
  const channelMetricsLastSyncedAt = newestOf(
    channels.map((channel) => channel.analytics?.channelLastUpdatedAt),
  )
  const commentsLastSyncedAt = newestOf(
    channels.map((channel) => channel.comments?.lastCheckedAt),
  )
  const overallLastSyncedAt = newestOf([
    postMetricsLastSyncedAt?.toISOString(),
    channelMetricsLastSyncedAt?.toISOString(),
    commentsLastSyncedAt?.toISOString(),
  ])

  return {
    loading,
    postMetricsLastSyncedAt,
    channelMetricsLastSyncedAt,
    commentsLastSyncedAt,
    overallLastSyncedAt,
    channelCount: channels.length,
  }
}
